import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class BoothDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
       ...props
    }
  }

  render(){
    const { boothId, url, name } = this.state.info;
    return(
      <Link to={`/booth/${boothId}`} className="booth-detail">
        <div className="img-wrapper">
          <img src={url} alt=""/>
        </div>
        <div className="info">
          <div><b>{name}</b> 닮은꼴 대잔치</div>
          <div>입장하기</div>
        </div>
      </Link>
    );
  }
}
export default BoothDetail;